import { PageLocatorMap } from '../types/PageLocatorMap';

export const vehicleConfirmationPage = {
  alert: {
    fetchOrUpdateError: 'vehicle-confirmation-page.alert.fetch-or-update-error',
  },
  footer: {
    root: 'vehicle-confirmation-page.footer.root',
  },
  form: {
    h1: 'vehicle-confirmation-page.form.h1',
    h2: 'vehicle-confirmation-page.form.h2',
    makeSelect: 'vehicle-confirmation-page.form.make-select',
    makeSelectError: 'vehicle-confirmation-page.form.make-select-error',
    modelSelect: 'vehicle-confirmation-page.form.model-select',
    modelSelectError: 'vehicle-confirmation-page.form.model-select-error',
    root: 'vehicle-confirmation-page.form.root',
    submitButton: 'vehicle-confirmation-page.form.submit-button',
    trimSelect: 'vehicle-confirmation-page.form.trim-select',
    trimSelectError: 'vehicle-confirmation-page.form.trim-select-error',
    yearSelect: 'vehicle-confirmation-page.form.year-select',
    yearSelectError: 'vehicle-confirmation-page.form.year-select-error',
  },
  header: {
    backButton: 'vehicle-confirmation-page.header.back-button',
    drawerButton: 'vehicle-confirmation-page.header.drawer-button',
    root: 'vehicle-confirmation-page.header.root',
  },
} as const satisfies PageLocatorMap;
